import { render, staticRenderFns } from "./PsConfigurationUsers.vue?vue&type=template&id=1a5728a9&scoped=true&"
import script from "./PsConfigurationUsers.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationUsers.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationUsers.vue?vue&type=style&index=0&id=1a5728a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5728a9",
  null
  
)

export default component.exports